import { useEffect } from "react";

import { LogSentryException } from "@shapr3d/frontend-lib";

import ZendeskLogOut from "../components/ZendeskLogOut/ZendeskLogOut";
import useUrlHelper from "../hooks/urlHelper";

const ZendeskLogOutContainer = () => {
  const urlHelper = useUrlHelper();

  const queryParams = urlHelper.getQueryParams();
  const isError = queryParams["kind"] === "error";

  const errorMessage = Array.isArray(queryParams["message"])
    ? queryParams["message"][0]
    : queryParams["message"];

  useEffect(() => {
    if (isError) {
      LogSentryException({
        messagePrefix: "Zendesk auth error",
        error: errorMessage,
        level: "info",
      });
    }
  }, [isError, errorMessage]);

  return (
    <ZendeskLogOut errorMessage={isError ? errorMessage || "Unknown error happened" : undefined} />
  );
};

export default ZendeskLogOutContainer;
